import { getProjectEndDate } from '../services/duration';
import dayjs, { Dayjs } from "dayjs";
interface MonthlyHours {
    month: string;
    hours: any[]
}

function addMonths(date: any, months: number) {
    const newDate = new Date(date);
    newDate.setMonth(newDate.getMonth() + months);

    // Handle month overflow (e.g., Feb 31 -> Mar 3)
    if (newDate.getDate() !== date.getDate()) {
        newDate.setDate(0); // Set to the last day of the previous month
    }

    return newDate;
}

const getLastDayOfMonthFromDate = (date: any) => {
    // Extract the year and month from the given date
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Month is 0-based, so add 1

    // Create a new date object set to the last day of the month
    const lastDayOfMonth = new Date(year, month, 0); // Day 0 means the last day of the previous month
    return lastDayOfMonth;
}

const  countCalendarMonthsBetween = (start: Dayjs, end: Dayjs): number => {
    // Calculate the difference in months
    let monthDiff = (end.year() - start.year()) * 12 + (end.month() - start.month());
    return monthDiff;
}

const getMonthlyWorkingHours = (
    startDate: string, // Format: 'YYYY-MM-DD'
    durationMonths: number,
    workHoursArray: any[],
    isDataExists: number
): MonthlyHours[] => {
    // Strip timezone info to prevent date shifting (e.g., "2026-04-01T00:00:00Z" → March 31 in US timezones)
    const cleanStartDate = startDate.replace(/T.*$/, '');
    const start = new Date(cleanStartDate + "T00:00:00");
    const result: MonthlyHours[] = [];

    const endDate = getProjectEndDate(cleanStartDate, durationMonths).add(1, 'day').toDate();

    const startDateDayjs = dayjs(cleanStartDate);
    const endDateDayjs =  getProjectEndDate(startDateDayjs, durationMonths)
    const monthsDiff = countCalendarMonthsBetween(startDateDayjs, endDateDayjs);
    const loopMonths = (isDataExists > 0 && isDataExists == durationMonths) ? isDataExists : monthsDiff;

    for (let i = 0; i <= loopMonths; i++) {
        // Get the current month being processed
        const currentDate = new Date(start.getFullYear(), start.getMonth() + i, 1);

        const daysInMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1,
            0
        ).getDate();

        let outputMonthlyHours: any = [];
        // let hoursForMonthUSCA = averageMonthlyUSCAHours;
        // let hoursForMonthIDC = averageMonthlyIDCHours;
        // let hoursForMonthLATAM = averageMonthlyLATAMHours;
        // let hoursForMonthEMEA = averageMonthlyEMEAHours;

        // Adjust the first month if start date isn't on the 1st
        // if (i === 0) {
        //     const remainingDays = daysInMonth - start.getDate() + 1;
        //     workHoursArray.forEach(element => {
        //         outputMonthlyHours.push({ "region": element.region, "resourceType": element.resource_type, "hours": Math.round((element.avg_work_hours_per_month / daysInMonth) * remainingDays) } as any);
        //     });
        //     // hoursForMonthUSCA = Math.round(
        //     //     (averageMonthlyUSCAHours / daysInMonth) * remainingDays
        //     // );
        //     // hoursForMonthIDC = Math.round(
        //     //     (averageMonthlyIDCHours / daysInMonth) * remainingDays
        //     // );
        //     // hoursForMonthLATAM = Math.round(
        //     //     (averageMonthlyLATAMHours / daysInMonth) * remainingDays
        //     // );
        //     // hoursForMonthEMEA = Math.round(
        //     //     (averageMonthlyEMEAHours / daysInMonth) * remainingDays
        //     // );
        // } 
        // else if (i === durationMonths && start.getDate() !== 1) {
        //     // Adjust the last month if it doesn't cover the full duration
        //     const coveredDays = getLastDayOfMonthFromDate(endDate).getDate(); // Days in the last month used

        //     workHoursArray.forEach(element => {
        //         outputMonthlyHours.push({ "region": element.region, "resourceType": element.resource_type, "hours": Math.round((element.avg_work_hours_per_month / 30) * coveredDays) } as any);
        //     });
        //     // hoursForMonthUSCA = Math.round(
        //     //     (averageMonthlyUSCAHours / 30) * coveredDays
        //     // );
        //     // hoursForMonthIDC = Math.round(
        //     //     (averageMonthlyIDCHours / 30) * coveredDays
        //     // );
        //     // hoursForMonthLATAM = Math.round(
        //     //     (averageMonthlyLATAMHours / 30) * coveredDays
        //     // );
        //     // hoursForMonthEMEA = Math.round(
        //     //     (averageMonthlyEMEAHours / 30) * coveredDays
        //     // );
        // }
        //  else {
        workHoursArray.forEach(element => {
            outputMonthlyHours.push({ "region": element.region, "resourceType": element.resource_type, "hours": Math.round(element.avg_work_hours_per_month) } as any);
        });
        // }

        result.push({
            month: dayjs(currentDate).format('MMM-YY').toUpperCase(),
            hours: outputMonthlyHours
        });
    }

    return result;
};

export default getMonthlyWorkingHours;
